// import { crypter } from '../../controllers/encrypt/encrypt';

/**
 * Check is value is null, undefined or empty string
  @param {String} s Tester value.
  @returns {boolean} true/false
*/
const IsNotNull = (s) => {
  return s ? true : false
}

/**
 * Check is pattern is matching
  @param {String} v Tester value.
  @param {String} regexp Tester value.
  @returns {boolean} true/false
*/
const patternCheck = (v, regexp) => {
  return regexp.test(v);
}

const FindOption = (find_value, st_opt) => {
  return IsNotNull(find_value) && IsNotNull(st_opt) ? st_opt.options.find(option => option.value === find_value) : ''
}

const setValue = async (value, fnv, st_v, fns, sd, se, rgx, krwe) => {
  // const setValue = async (props) => {
  // console.log(props);
  let msg = '';
  let style = sd;
  let v_temp = '';
  let cr = patternCheck(value, rgx);
  if (!cr && value.length > 0) {
    // msg = em
    style = se
    v_temp = krwe ? value : st_v
    // IsNotNull(tnotif) ? tnotif(em, { variant: "error", autoHideDuration: 1200 }) : null
  } else {
    v_temp = value;
    msg = ''
    style = sd;
  }
  fnv(v_temp)
  fns(style)
  // IsNotNull(fnv) ? fnv(v_temp) : null
  // IsNotNull(sem) ? await troot.setState({ [sem]: msg }) : null
  // IsNotNull(fns) ? fns(style) : null
}

// const encrypt =(x)=>{
//   return crypter().encrypt(x);
// }

// const decrypt =(x)=>{
//   return crypter().decrypt(x);
// }


export {
  IsNotNull,
  patternCheck,
  FindOption,
  setValue,
  // encrypt,
  // decrypt
}